import { useEffect } from "react";
import MySitePhotoModel from "../../../models/mySite/mySitePhotoModel";
import MySitePhoneModel from "../../../models/mySite/mySitePhoneModel";
import MySiteTextModel from "../../../models/mySite/mySiteTextModel";
import MySiteVideoModel from "../../../models/mySite/mySiteVideoModel";
import MySiteSocialMediaModel from "../../../models/mySite/mySiteSocialMediaModel";
import MySiteGalleryModel from "../../../models/mySite/mySiteGalleryModel";
import MySiteSliderModel from "../../../models/mySite/mySiteSliderModel";
import { PartitionType } from "../../../models/enums/partitionType";
import { MySiteDetailsResponse } from "../../../models/mySite/mySiteDetalisResponse";
import { useAppSelector } from "../../../app/redux/hooks";
import {
  selectMySiteDetails,
  selectMySiteGallery,
  selectMySitePhone,
  selectMySitePhoto,
  selectMySiteSlider,
  selectMySiteSocialMedia,
  selectMySiteText,
  selectMySiteVideo,
} from "../../../slices/mySiteSlice";
import { toKey } from "../utilis";

const useWebsiteDetailsEffect = (
  setSelectedItems: (prevItems: any) => void,
  setMySitePhotoSection: (
    prevSections: (prevSections: MySitePhotoModel[]) => MySitePhotoModel[]
  ) => void,
  setMySiteTextSection: (
    prevSections: (prevSections: MySiteTextModel[]) => MySiteTextModel[]
  ) => void,
  setMySitePhoneSection: (
    prevSections: (prevSections: MySitePhoneModel[]) => MySitePhoneModel[]
  ) => void,
  setMySiteVideoSection: (
    prevSections: (prevSections: MySiteVideoModel[]) => MySiteVideoModel[]
  ) => void,
  setMySiteSocialMediaSection: (
    prevSections: (
      prevSections: MySiteSocialMediaModel[]
    ) => MySiteSocialMediaModel[]
  ) => void,
  setMySiteGallerySection: (
    prevSections: (prevSections: MySiteGalleryModel[]) => MySiteGalleryModel[]
  ) => void,
  setMySiteSliderSection: (
    prevSections: (prevSections: MySiteSliderModel[]) => MySiteSliderModel[]
  ) => void
) => {
  const mySitePartitions = useAppSelector((state) => ({
    photo: selectMySitePhoto(state),
    phone: selectMySitePhone(state),
    text: selectMySiteText(state),
    video: selectMySiteVideo(state),
    socialMedia: selectMySiteSocialMedia(state),
    gallery: selectMySiteGallery(state),
    slider: selectMySiteSlider(state),
    websiteDetails: selectMySiteDetails(state),
  }));

  useEffect(() => {
    if (mySitePartitions.websiteDetails) {
      mySitePartitions.websiteDetails.forEach(
        (detail: MySiteDetailsResponse) => {
          setSelectedItems((prevItems: any) => ({
            ...prevItems,
            [toKey(detail.orderNumber)]: {
              value: PartitionType[detail.partitionType],
              orderNumber: detail.orderNumber,
              id: detail.id,
            },
          }));
          switch (detail.partitionType as PartitionType) {
            case PartitionType.Photo:
              setMySitePhotoSection((prevSections: MySitePhotoModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  base64Photo: detail.photoPath ? detail.photoPath : "",
                },
              ]);
              break;
            case PartitionType.Text:
              setMySiteTextSection((prevSections: MySiteTextModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  value: detail.text ? detail.text : "",
                },
              ]);
              break;
            case PartitionType.Phone:
              setMySitePhoneSection((prevSections: MySitePhoneModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  phones: detail.phones ? detail.phones : [],
                },
              ]);
              break;
            case PartitionType.Video:
              setMySiteVideoSection((prevSections: MySiteVideoModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  link: detail.text ? detail.text : "",
                },
              ]);
              break;
            case PartitionType.SocialMedia:
              setMySiteSocialMediaSection(
                (prevSections: MySiteSocialMediaModel[]) => [
                  ...prevSections,
                  {
                    id: detail.id,
                    orderNumber: detail.orderNumber,
                    socialMedias: detail.socialMedias
                      ? detail.socialMedias
                      : [],
                  },
                ]
              );
              break;
            case PartitionType.Gallery:
              setMySiteGallerySection((prevSections: MySiteGalleryModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  base64Photos: detail.photoPaths ? detail.photoPaths : [],
                  isGallery: true,
                },
              ]);
              break;
            case PartitionType.Slider:
              setMySiteSliderSection((prevSections: MySiteSliderModel[]) => [
                ...prevSections,
                {
                  id: detail.id,
                  orderNumber: detail.orderNumber,
                  base64Photos: detail.photoPaths ? detail.photoPaths : [],
                  isSlider: true,
                },
              ]);
              break;
            default:
              break;
          }
        }
      );
    }
  }, [
    mySitePartitions.websiteDetails,
    setSelectedItems,
    setMySitePhotoSection,
    setMySiteTextSection,
    setMySitePhoneSection,
    setMySiteVideoSection,
    setMySiteSocialMediaSection,
    setMySiteGallerySection,
    setMySiteSliderSection,
  ]);
};

export default useWebsiteDetailsEffect;
